import React from "react";
import {Image, View, Flex, useTheme, Grid} from "@aws-amplify/ui-react";
import coachingLogoWhite from '../../assets/images/logo/logo-white.svg';
import styles from "./index.module.css";
import Footer from "../../components/NoAuth/Footer";


export default function CookiePolicy() {
  const {tokens} = useTheme();

  const mainFlexClassNames = ["auth-wrapper", styles.mainFlex];

  return (
    <Flex
      direction="row"
      justifyContent="center"
      className={mainFlexClassNames.join(" ")}
    >
      <View
        className={styles.contentView}
      >
        {/*header logo*/}
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Myedu logo"
            src={coachingLogoWhite}
          />
        </View>


        <View className={styles.registerWrapper}>
          <Grid
            templateColumns={{base: "1fr", medium: "2fr 1fr", large: "4fr 1fr"}}
            templateRows={{base: "repeat(5, auto)", medium: "repeat(4, auto"}}
            className={styles.mainGrid}
          >
            <View
              className={styles.titleViewWrapper}
              columnSpan={[1, 1, 2, 2]}
            >
              <h1>Ufficio Assistenza</h1>
              <p>
                Il servizio di assistenza è gratuito e disponibile<br/>
                dalle 10.00 alle 13.00 e dalle 14.00 alle 19.00<br/>
                nei giorni feriali contattando i numeri:<br/>
                <a href="tel:+390230076303">02 30076303</a><br/>
                <a href="tel:+393278882745">327 8882745</a>&nbsp;
                <a href="https://api.whatsapp.com/send?phone=00393278882745" target="_blank" rel="noopener noreferrer">
                  (assistenza whatsapp)
                </a><br/>
                oppure scrivendo a:<br/>
                <a href="mailto:team@myedu.it">team@myedu.it</a>
              </p>
            </View>
          </Grid>
        </View>

        {/*footer text*/}
        <Footer/>
      </View>
    </Flex>
  );
}